import { render } from "./DetailTopNav.vue?vue&type=template&id=b7de5b8c"
import script from "./DetailTopNav.vue?vue&type=script&lang=js"
export * from "./DetailTopNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__